/**
 * lib/booking.js — Sarabi Booking API client + helpers.
 */
import { api } from "@/lib/api";

export const bookingApi = {
  config: () => api.get("/booking/config").then((r) => r.data),
  lookup: (phone) => api.get(`/booking/customer-lookup?phone=${encodeURIComponent(phone)}`).then((r) => r.data),
  slotLoad: (date, time, pax) =>
    api.get(`/booking/slot-load?date=${date}&time=${time}&pax=${pax || 0}`).then((r) => r.data),
  create: (body, override = false) =>
    api.post(`/booking/reservations${override ? "?override=true" : ""}`, body).then((r) => r.data),
};

export const publicProfileApi = {
  get: (token) => api.get(`/public/profile/${token}`).then((r) => r.data),
  submit: (token, body) => api.post(`/public/profile/${token}`, body).then((r) => r.data),
};

// ---------------------------------------------------------------------------
// Formattazione umana del semaforo — testi approvati dal product.
// ---------------------------------------------------------------------------
export function humanSlotMessage(load) {
  if (!load) return null;
  const { status, current_load, would_be, max_covers } = load;
  const suggested = (load.suggestions || [])
    .filter((s) => s.status !== "red")
    .slice(0, 2)
    .map((s) => s.time);
  if (status === "green") {
    return {
      icon: "🟢",
      tone: "green",
      title: "Fascia disponibile",
      body: `Con questa prenotazione arriverai a ${would_be}/${max_covers} coperti.`,
      suggested,
    };
  }
  if (status === "yellow") {
    return {
      icon: "🟡",
      tone: "yellow",
      title: "Fascia quasi piena",
      body: `Con questa prenotazione arriverai a ${would_be}/${max_covers} coperti.`,
      suggested,
    };
  }
  return {
    icon: "🔴",
    tone: "red",
    title: "Fascia oltre il limite",
    body: `Con questa prenotazione arriverai a ${would_be}/${max_covers} coperti. Ti consigliamo:`,
    suggested,
  };
}

export function euros(cents) {
  const c = Number(cents || 0);
  return "€ " + (c / 100).toFixed(2).replace(".", ",");
}
